var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"invoice-payment-redirect-page"}},[_c('vs-alert',{attrs:{"color":"danger","title":_vm.$t('InvoiceGroupNotifyTitle'),"active":_vm.not_found},on:{"update:active":function($event){_vm.not_found=$event}}},[_c('span',[_vm._v(_vm._s(_vm.$t('InvoiceGroupNotifyDesc')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }